'use client';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { CartCount } from '@/entities/cart';
import { PageContext } from '@/features/app-providers/page-provider';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { Icon } from '@/shared/ui/icon';
import { BottomPanelTab } from './bottom-panel-tab';
import './bottom-panel.scss';
import { BottomPanelTabPremadePropsWithCount } from './types';

type Props = Omit<BottomPanelTabPremadePropsWithCount, 'isIconVisible' | 'isTitleVisible'>;
export const BottomPanelCartTab = ({ ...props }: Props) => {
    const t = useTranslations();
    const getPageUrl = useGetPageUrl();
    const { pageName } = useContext(PageContext);

    const href = getPageUrl('cart');

    return (
        <BottomPanelTab
            icon={
                <div className="bottom-panel__cart-icon-wrapper">
                    <Icon name="bag" width={40} height={40} />
                    <CartCount className="bottom-panel__cart__count" />
                </div>
            }
            href={href}
            title={t('BOTTOM_PANEL.CART')}
            {...props}
            isTitleVisible={false}
            isActive={pageName === 'cart'}
            data-testid="bottom-panel-cart-tab"
        />
    );
};
